module.exports = __webpack_public_path__ + "fonts/dxicons.2b145cef.woff";